import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  public $breadCrumbChild: Subject<string> = new Subject<string>();

  constructor() {}
}
